//Life Style Card Enums
export const alcoholEnum = {
  question: "How often do you drink alcohol?",
  subquestion: null,
  options: [
    {
      value: "Binge",
      header: "Binge intake (Drinks per event)",
      subHeader: "Men: 5 or more / Women: 4 or more",
    },
    {
      value: "Heavy",
      header: "Heavy intake",
      subHeader: "6 or more drinks per week",
    },
    {
      value: "Moderate",
      header: "Moderate intake",
      subHeader: "3 to 6 drinks per week",
    },
    {
      value: "Low",
      header: "Low intake",
      subHeader: "2 standard drinks per week",
    },
    { value: "Never", header: "Never", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const caffeineEnum = {
  question: "How often do you drink caffeine?",
  subquestion: "(coffee, tea, energy drinks, soft drinks)",
  options: [
    { value: "High", header: "More than 2 cups per day", subHeader: null },
    { value: "Moderate", header: "1 or 2 cups per day", subHeader: null },
    { value: "Low", header: "Occasional", subHeader: null },
    { value: "Never", header: "Never", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const smokingEnum = {
  question: "How many cigarettes do you smoke per day?",
  subquestion: null,
  options: [
    {
      value: "Heavy",
      header: "Heavy smoker",
      subHeader: "20 or more cigarettes per day",
    },
    {
      value: "Light",
      header: "Light intake",
      subHeader: "11 - 19 cigarettes per day",
    },
    {
      value: "Social",
      header: "Social intake",
      subHeader: "1 - 10 cigarettes per day",
    },
    { value: "Never", header: "None", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const recreationalDrugsEnum = {
  question: "What recreational drug(s) do you use?",
  subquestion: "Select all that apply",
  options: [
    { value: "Cannabis", header: "Cannabis", subHeader: null },
    { value: "Cocaine", header: "Cocaine", subHeader: null },
    { value: "Other", header: "Other", subHeader: null },
    { value: "None", header: "None", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const dietEnum = {
  question: "Select if any of the following are part of your diet",
  subquestion: null,
  options: [
    { value: "Grapefruit", header: "Grapefruit", subHeader: null },
    { value: "Bananas", header: "Bananas", subHeader: null },
    { value: "DairyProducts", header: "Dairy Products", subHeader: null },
    { value: "LactoseFreeDiet", header: "Lactose Free Diet", subHeader: null },
    { value: "GlutenFreeDiet", header: "Gluten Free Diet", subHeader: null },
    { value: "None", header: "None", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const exerciseEnum = {
  question: "How often do you exercise?",
  subquestion: null,
  options: [
    { value: "Low", header: "1 to 2 times per week", subHeader: null },
    { value: "Moderate", header: "3 to 4 times per week", subHeader: null },
    { value: "High", header: "5 to 7 times per week", subHeader: null },
    { value: "Sports", header: "Sports Competition", subHeader: null },
    { value: "Never", header: "No Exercise", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

export const exerciseTypeEnum = {
  question: "Select type(s) of exercise:",
  subquestion: null,
  options: [
    { value: "Walk", header: "Walk, bike, jog, swim", subHeader: null },
    { value: "Weight", header: "Weights, aerobic, yoga", subHeader: null },
    { value: "Sports", header: "Sports", subHeader: null },
    { value: "Household", header: "Household chores", subHeader: null },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const culturalEnum = {
  question: "Factors that may influence medication treatment.",
  subquestion: "Select all that apply.",
  options: [
    { value: "Cultural", header: "Cultural Factors", subHeader: null },
    { value: "Ethnical", header: "Ethical Factors", subHeader: null },
    { value: "Religious", header: "Religious Factors", subHeader: null },
    { value: "None", header: "None", subHeader: null },
    { value: "Not Assessed", header: "Not Assessed", subHeader: null },
  ],
};

//Medical Conditions Card Enums
export const acuteMCEnum = {
  question: "Do you have any of the following conditions?",
  subquestion: "Select all that apply.",
  options: [
    {
      value: "sinusitis",
      header: "Recurrent or Chronic Sinusitis",
      code: "IN9S",
      subHeader: null,
    },
    {
      value: "otitis media",
      code: "INBM",
      header: "Otitis Media (Ear Infection)",
      subHeader: null,
    },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const chronicMCEnum = {
  question: "Do you have any of the following conditions?",
  subquestion: "Select all that apply.",
  options: [
    { value: "asthma", code: "MPA_", header: "Asthma", subHeader: null },
    {
      value: "hypothyroidism",
      code: "PATO",
      header: "Thyroid condition (HYPOthyroidism)",
      subHeader: null,
    },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const getMCEnumHeader = (value) => {
  const options = [
    ...acuteMCEnum.options.filter((i) => i.value !== "None"),
    ...chronicMCEnum.options.filter((i) => i.value !== "None"),
  ];
  const option = options.find((option) => option.value === value);
  return option ? option.header : value;
};

//Drug Induced Card Enums
export const cardiacMedEnum = {
  question: (
    <>
      Did Symptoms begin with the <b>start of new medications?</b> Select all
      that apply.
    </>
  ),
  subquestion: null,
  options: [
    { value: "ACE Inhibitors", header: "ACE Inhibitors", subHeader: null },
    { value: "Alpha Blockers", header: "Alpha Blockers", subHeader: null },
    { value: "Beta Blockers", header: "Beta Blockers", subHeader: null },
    { value: "Calcium Channel Blockers", header: "Calcium Channel Blockers", subHeader: null },
    { value: "Clonidine", header: "Clonidine", subHeader: null },
    { value: "Diuretics", header: "Diuretics", subHeader: null },
    { value: "Other", header: "Other", subHeader: null },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const oralMedEnum = {
  question: (
    <>
      Did symptoms begin with the <b>start of using Oral Contraceptives?</b>
    </>
  ),
  subquestion: null,
  options: [
    { value: "Yes", header: "Yes", subHeader: null },
    { value: "No", header: "No", subHeader: null },
    { value: "Does not apply", header: "Not Applicable", subHeader: null },
  ],
};

export const otherPresEnum = {
  question: (
    <>
      Did Symptoms begin with the <b>start of new medications?</b> Select all
      that apply.
    </>
  ),
  subquestion: null,
  options: [
    { value: "Chlorpromazine", header: "Chlorpromazine", subHeader: null },
    { value: "Gabapentin", header: "Gabapentin", subHeader: null },
    { value: "Cyclosporine", header: "Cyclosporine", subHeader: null },
    { value: "NSAIDS", header: "NSAIDS", subHeader: null },
    {
      value: "Nasal Decongestants",
      header: "Nasal Decongestants",
      subHeader: null,
    },
    { value: "Other", header: "Other", subHeader: null },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const nonPresEnum = {
  question: (
    <>
      Did Symptoms begin with the <b>start of new medications?</b> Select all
      that apply.
    </>
  ),
  subquestion: null,
  options: [
    {
      value: "Nasal Decongestants",
      header: "Nasal Decongestants",
      subHeader: null,
    },
    { value: "NSAIDS", header: "NSAIDS", subHeader: null },
    { value: "Aspirin", header: "Aspirin (ASA)", subHeader: null },
    {
      value: "Herbals or Vitamins",
      header: "Herbals or Vitamins",
      subHeader: null,
    },
    { value: "Other", header: "Other", subHeader: null },
    { value: "None", header: "None", subHeader: null },
  ],
};

export const MedicalHistoryTypes = {
  Condition: "MedicalCondition",
  Study: "MedicalStudy",
  Surgery: "MedicalSurgery",
};

export const getHistoryTypeName = (type) => {
  if (type === MedicalHistoryTypes.Condition) return "Medical Condition";
  else if (type === MedicalHistoryTypes.Study) return "Medical Study";
  else if (type === MedicalHistoryTypes.Surgery) return "Surgery/ Procedure";
};

export const typeOptions = [
  { value: "allergy", label: "Allergy" },
  { value: "intolerance", label: "Intolerance" },
  { value: "sideEffects", label: "Side effects" },
  { value: "adverseReactions", label: "Adverse Reactions" },
];
export const categoryOptions = [
  { value: "animalAllergy", label: "Animal" },
  { value: "drugAllergy", label: "Drug" },
  { value: "environmentalAllergy", label: "Environmental" },
  { value: "foodAllergy", label: "Food" },
  { value: "latexAllergy", label: "Latex" },
  { value: "miscellaneousAllergy", label: "Miscellaneous" },
  {
    value: "miscellaneousContraindication",
    label: "Miscellaneous Contraindication",
  },
  { value: "plantAllergy", label: "Plant" },
  { value: "pollenAllergy", label: "Pollen" },
  { value: "vaccinesAllergy", label: "Vaccines" },
];

 export const reactionOptions = [
    { value: "Not Known", label: "Not Known" },
    { value: "Not Specified", label: "Not Specified" },
  ];

export const severityOptions = [
  { value: "notKnown", label: "Not Known" },
  { value: "notSpecified", label: "Not Specified" },
  { value: "mild", label: "Mild" },
  { value: "moderate", label: "Moderate" },
  { value: "severe", label: "Severe" },
];
export const sourceOptions = [
  { value: "patient", label: "Patient" },
  { value: "familyMember", label: "Family Member" },
  { value: "caregiver", label: "Alternate Caregiver" },
  { value: "familyPhysician", label: "Primary Provider" },
  { value: "otherPhysician", label: "Other Physician (Specialty)" },
  { value: "nursePractitioner", label: "Nurse Practitioner" },
  { value: "nurse", label: "Nurse" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "medAlert", label: "Med Alert Bracelet" },
];

export const recentStartOptions = [
  { value: null, label: "Confirm Recent Start" },
  { value: true, label: "Medication is a Recent start" },
  { value: false, label: "Medication is NOT a recent start" },
];
export const reasonOptions = [
  { label: "None", value: "none" },
  { label: "Not Specified", value: "not_specified" },
  { label: "Other", value: "Other" },
  { label: "agitation, mild", value: "agitation_mild_agi_" },
  { label: "agitation, moderate", value: "agitation_moderate_agi_" },
  { label: "agitation, severe", value: "agitation_severe_agi_" },
  { label: "alcohol withdrawal symptoms", value: "alcohol_withdrawal_symptoms" },
  { label: "allergy symptoms", value: "allergy_symptoms_in@r" },
  { label: "allergic rhinitis", value: "allergic_rhinitis_rhia" },
  { label: "anaphylaxis", value: "anaphylaxis_ana_" },
  { label: "angina", value: "angina_mca_" },
  { label: "anxiety", value: "anxiety_anx_" },
  { label: "atrial fibrillation", value: "atrial_fibrillation_mcrf" },
  { label: "back pain", value: "back_pain_domd" },
  { label: "bladder infection", value: "bladder_infection_in2u" },
  { label: "bleeding", value: "bleeding_sai_" },
  { label: "blood glucose", value: "blood_glucose" },
  { label: "blood pressure", value: "blood_pressure_mcy_" },
  { label: "blood sugar", value: "blood_sugar" },
  { label: "bowel movements", value: "bowel_movements" },
  { label: "bronchospasm", value: "bronchospasm_mps_" },
  { label: "canker sores", value: "canker_sores_bout" },
  { label: "chest congestion", value: "chest_congestion_cog_" },
  { label: "chest pain", value: "chest_pain_dot_" },
  { label: "cholesterol", value: "cholesterol_dysc" },
  { label: "chronic kidney disease", value: "chronic_kidney_disease_rin_" },
  { label: "chronic pain", value: "chronic_pain_doe_" },
  { label: "chronic sinusitis", value: "chronic_sinusitis_in9s" },
  {
    label: "chronic or recurrent sinusitis",
    value: "chronic_or_recurrent_sinusitis_in9s",
  },
  { label: "congestion", value: "congestion_cog_" },
  { label: "constipation", value: "constipation_gic_" },
  { label: "cough", value: "cough_mpx_" },
  { label: "delirium", value: "delirium_del_" },
  { label: "diarrhea", value: "diarrhea_gid_" },
  { label: "dialysis", value: "dialysis_prc_" },
  { label: "dizziness", value: "dizziness_ver_" },
  { label: "dry eyes", value: "dry_eyes_sec_" },
  { label: "dry mouth", value: "dry_mouth_boux" },
  { label: "dry skin", value: "dry_skin_dmtx" },
  { label: "dyslipidemia", value: "dyslipidemia_dysc" },
  { label: "dyspepsia", value: "dyspepsia_gi#_" },
  { label: "dyspnea", value: "dyspnea_mpd_" },
  { label: "ear infection", value: "ear_infection_inbm" },
  { label: "ear wax", value: "ear_wax_cio_" },
  { label: "fever", value: "fever_fie_" },
  { label: "flu symptoms", value: "flu_symptoms_inz2" },
  { label: "headache", value: "headache_cep_" },
  { label: "heart rate", value: "heart_rate_mcrt" },
  { label: "heart rhythm", value: "heart_rhythm_mcr_" },
  { label: "heartburn", value: "heartburn_gi#_" },
  { label: "hemorrhoids", value: "hemorrhoids_gim_" },
  { label: "high blood glucose", value: "high_blood_glucose_dia_" },
  { label: "high blood pressure", value: "high_blood_pressure_mcy_" },
  { label: "high blood sugar", value: "high_blood_sugar_dia_" },
  { label: "high cholesterol", value: "high_cholesterol_dysc" },
  { label: "hypoglycemia", value: "hypoglycemia_diao" },
  { label: "hypertension", value: "hypertension_mcy_" },
  { label: "hypercholesterolemia", value: "hypercholesterolemia_dysc" },
  { label: "hyperglycemia", value: "hyperglycemia_dia_" },
  { label: "hypotension", value: "hypotension_mco_" },
  { label: "indigestion", value: "indigestion_gi#_" },
  { label: "infection", value: "infection" },
  { label: "inflammation", value: "inflammation_fla_" },
  { label: "insomnia", value: "insomnia_trsi" },
  { label: "irritable bowel syndrome", value: "irritable_bowel_syndrome_gii_" },
  { label: "itchiness", value: "itchiness_pru_" },
  { label: "itching", value: "itching_pru_" },
  { label: "itching skin", value: "itching_skin_urt_" },
  { label: "itchy eyes", value: "itchy_eyes" },
  { label: "itchy nose", value: "itchy_nose" },
  { label: "joint pain", value: "joint_pain_dor_" },
  { label: "kidney disease", value: "kidney_disease_rin_" },
  { label: "kidney injury", value: "kidney_injury" },
  { label: "leg cramps", value: "leg_cramps_cjn_" },
  { label: "loose stool", value: "loose_stool_gid_" },
  { label: "low blood pressure", value: "low_blood_pressure_mco_" },
  { label: "low blood sugar", value: "low_blood_sugar_diao" },
  { label: "migraine", value: "migraine_cepm" },
  { label: "migraine headache", value: "migraine_headache_cepm" },
  { label: "motion sickness", value: "motion_sickness_mat_" },
  { label: "mouth sore pain", value: "mouth_sore_pain_bout" },
  { label: "muscle pain", value: "muscle_pain_dom_" },
  { label: "muscle spasm", value: "muscle_spasm_spam" },
  { label: "nasal congestion", value: "nasal_congestion_cogn" },
  { label: "nasal discharge", value: "nasal_discharge_in@r" },
  { label: "nausea", value: "nausea_giu_" },
  { label: "nausea & vomiting", value: "nausea_vomiting_giu_" },
  { label: "nicotine withdrawal", value: "nicotine_withdrawal" },
  { label: "pain", value: "pain_do__" },
  { label: "pain breakthrough", value: "pain_breakthrough_do__" },
  { label: "pain mild", value: "pain_mild_do__" },
  { label: "pain moderate", value: "pain_moderate_do__" },
  { label: "pain severe", value: "pain_severe_do__" },
  { label: "pruritus", value: "pruritus_pru_" },
  { label: "productive cough", value: "productive_cough_mpxp" },
  { label: "rash", value: "rash_eru_" },
  { label: "recurrent sinusitis", value: "recurrent_sinusitis_in9s" },
  { label: "respiratory distress", value: "respiratory_distress_mpdd" },
  { label: "restlessness", value: "restlessness_agi_" },
  { label: "rhinorrhea", value: "rhinorrhea_in@r" },
  { label: "seasonal allergy", value: "seasonal_allergy_allr" },
  { label: "sedation", value: "sedation_trsi" },
  { label: "seizures", value: "seizures_con_" },
  { label: "shortness of breath", value: "shortness_of_breath_mpd_" },
  { label: "sinus congestion", value: "sinus_congestion_cogs" },
  { label: "sinusitis", value: "sinusitis_in9s" },
  { label: "skin irritation", value: "skin_irritation_ethm" },
  { label: "skin redness", value: "skin_redness_ethm" },
  { label: "sleep", value: "sleep_trsi" },
  { label: "smoking cessation", value: "smoking cessation_tabd" },
  { label: "sneezing", value: "sneezing" },
  { label: "sore throat", value: "sore_throat_dog_" },
  { label: "spasms", value: "spasms_spa_" },
  { label: "stomach acid", value: "stomach_acid_gi#_" },
  { label: "stomach upset", value: "stomach_upset_gi#_" },
  { label: "stroke prevention", value: "stroke_prevention" },
  { label: "swelling", value: "swelling_oed_" },
  { label: "swimmers ear", value: "swimmers_ear_inbe" },
  {
    label: "symptoms of alcohol withdrawal",
    value: "symptoms_of_alcohol_withdrawal",
  },
  { label: "tremors", value: "tremors_tre_" },
  { label: "twitching", value: "twitching" },
  { label: "urinary discomfort", value: "urinary_discomfort_dou_" },
  { label: "urinary incontinence", value: "urinary_incontinence_enu_" },
  { label: "urinary infection", value: "urinary_infection_in2u" },
  { label: "urinary obstruction", value: "urinary_obstruction_rtuo" },
  { label: "urine infection", value: "urine_infection_in2u" },
  { label: "vaccine history", value: "vaccine_history_imm_" },
  { label: "vaccine schedule", value: "vaccine_schedule_imm_" },
  { label: "vertigo", value: "vertigo_ver_" },
  { label: "weight loss", value: "weight_loss" },
  { label: "Wheezing", value: "wheezing_mpd_" },
  { label: "other (see comments)", value: "other_see_comments" },
];

export const unitOptions = [
  { label: "day", value: "day" },
  { label: "week", value: "week" },
  { label: "month", value: "month" },
  { label: "dose", value: "dose" },
  { label: "hour", value: "hour" },
  { label: "minute", value: "minute" },
  { label: "times", value: "times" },
];

export const PRN_FREQUENCY_VALUES = ["Take as Needed", "Use as Needed", "Apply as Needed"];

export const frequencyOptions = [
  {
    label: "As Needed (PRN)",
    options: [
      { label: "Take as Needed", value: "Take as Needed" },
      { label: "Use as Needed", value: "Use as Needed" },
      { label: "Apply as Needed", value: "Apply as Needed" },
    ],
  },
  {
    label: "As directed",
    options: [
      { label: "As Directed", value: "As Directed" },
      {
        label: "As Directed, See Comments",
        value: "As Directed, See Comments",
      },
    ],
  },
  {
    label: "Times Daily",
    options: [
      { label: "5x/day", value: "5x/day" },
      { label: "6x/day", value: "6x/day" },
      { label: "7x/day", value: "7x/day" },
      { label: "8x/day", value: "8x/day" },
      { label: "9x/day", value: "9x/day" },
      { label: "10x/day", value: "10x/day" },
      { label: "11x/day", value: "11x/day" },
      { label: "12x/day", value: "12x/day" },
    ],
  },
  {
    label: "After Meals",
    options: [
      { label: "after breakfast", value: "after breakfast" },
      { label: "after lunch", value: "after lunch" },
      { label: "after supper", value: "after supper" },
      { label: "after meals", value: "after meals" },
      { label: "after meals and hs", value: "after meals and hs" },
    ],
  },
  {
    label: "Before Meals",
    options: [
      { label: "before breakfast", value: "before breakfast" },
      { label: "before lunch", value: "before lunch" },
      { label: "before supper", value: "before supper" },
      { label: "before meals", value: "before meals" },
      { label: "before meals and hs", value: "before meals and hs" },
      { label: "before hs", value: "before hs" },
      { label: "before snacks", value: "before snacks" },
    ],
  },
  {
    label: "BID (Twice Daily)",
    options: [
      { label: "BID", value: "BID", fullLabel: "twice daily" },
      { label: "BID before meals", value: "BID before meals", fullLabel: "twice daily before meals" },
      { label: "BID after meals", value: "BID after meals", fullLabel: "twice daily after meals" },
      { label: "BID with meals", value: "BID with meals", fullLabel: "twice daily with meals" },
      { label: "BID with meals and hs", value: "BID with meals and hs", fullLabel: "twice daily with means & HS" },
      { label: "BID Mon/Wed/Fri", value: "BID Mon/Wed/Fri", fullLabel: "twice daily Mon/Wed/Fri" },
    ],
  },
  {
    label: "Daily",
    options: [
      { label: "Once a day", value: "once a day" },
      { label: "Daily", value: "Daily" },
      { label: "daily before meal", value: "daily before meal" },
      { label: "daily after meal", value: "daily after meal" },
      { label: "daily with meal", value: "daily with meal" },
      { label: "day of treatment", value: "day of treatment" },
      { label: "ON call", value: "ON call" },
      { label: "Once", value: "Once" },
    ],
  },
  {
    label: "HS (At Bedtime)",
    options: [
      { label: "HS", value: "HS" },
      { label: "HS mon wed fri", value: "HS mon wed fri" },
      { label: "HS tues thurs sat", value: "HS tues thurs sat" },
      { label: "HS tues thurs sat sun", value: "HS tues thurs sat sun" },
    ],
  },
  {
    label: "Other Frequencies",
    options: [
      { label: "PreOp", value: "PreOp" },
      { label: "Prior", value: "Prior" },
      { label: "q10days", value: "q10days", fullLabel: "every 10 days" },
      { label: "q10hours", value: "q10hours", fullLabel: "every 10 hours" },
      { label: "q10min", value: "q10min", fullLabel: "every 10 min" },
      { label: "q120days", value: "q120days", fullLabel: "every 120 days" },
      { label: "q12h", value: "q12h", fullLabel: "every 12 hours" },
      { label: "q12weeks", value: "q12weeks", fullLabel: "every 12 weeks" },
      { label: "q15min", value: "q15min", fullLabel: "every 15 min" },
      { label: "q15weeks", value: "q15weeks", fullLabel: "every 15 weeks" },
      { label: "q1hour", value: "q1hour", fullLabel: "every hour" },
      { label: "q1month", value: "q1month", fullLabel: "every month" },
      { label: "q1week", value: "q1week", fullLabel: "every week" },
      { label: "q1year", value: "q1year", fullLabel: "every year" },
      {
        label: "q20minutes",
        value: "q20minutes",
        fullLabel: "every 20 minutes",
      },
      { label: "q24hours", value: "q24hours", fullLabel: "every 24 hours" },
      { label: "q24weeks", value: "q24weeks", fullLabel: "every 24 weeks" },
      { label: "q28days", value: "q28days", fullLabel: "every 28 days" },
      { label: "q2days", value: "q2days", fullLabel: "every 2 days" },
      { label: "q2hours", value: "q2hours", fullLabel: "every 2 hours" },
      { label: "q2weeks", value: "q2weeks", fullLabel: "every 2 weeks" },
      { label: "q30days", value: "q30days", fullLabel: "every 30 days" },
      { label: "q30minutes", value: "q30minutes", fullLabel: "every 30 minutes" },
      { label: "q36hours", value: "q36hours", fullLabel: "every 36 hours" },
      { label: "q3days", value: "q3days", fullLabel: "every 3 days" },
      { label: "q3hours", value: "q3hours", fullLabel: "every 3 hours" },
      { label: "q3months", value: "q3months", fullLabel: "every 3 months" },
      { label: "q3weeks", value: "q3weeks", fullLabel: "every 3 weeks" },
      { label: "q48hours", value: "q48hours", fullLabel: "every 48 hours" },
      { label: "q4hours", value: "q4hours", fullLabel: "every 4 hours" },
      { label: "q4days", value: "q4days", fullLabel: "every 4 days" },
      { label: "q4months", value: "q4months", fullLabel: "every 4 months" },
      { label: "q4weeks", value: "q4weeks", fullLabel: "every 4 weeks" },
      { label: "q5days", value: "q5days", fullLabel: "every 5 days" },
      { label: "q5hours", value: "q5hours", fullLabel: "every 5 hours" },
      { label: "q6hours", value: "q6hours", fullLabel: "every 6 hours" },
      { label: "q6hourswhileawake", value: "q6hourswhileawake", fullLabel: "every 6 hours while awake" },
      { label: "q6months", value: "q6months", fullLabel: "every 6 months" },
      { label: "q6weeks", value: "q6weeks", fullLabel: "every 6 weeks" },
      { label: "q72hours", value: "q72hours", fullLabel: "every 72 hours" },
      { label: "q7days", value: "q7days", fullLabel: "every 7 days" },
      { label: "q8hours", value: "q8hours", fullLabel: "every 8 hours" },
      { label: "q8weeks", value: "q8weeks", fullLabel: "every 8 weeks" },
      { label: "q90days", value: "q90days", fullLabel: "every 90 days" },
      { label: "qAM &qHS", value: "qAM &qHS" },
      { label: "qEvening", value: "qEvening", fullLabel: "every evening" },
      { label: "qFriday", value: "qFriday", fullLabel: "every Friday" },
      { label: "QID", value: "QID", fullLabel: "four times daily" },
      { label: "qMon", value: "qMon", fullLabel: "every Mon" },
      { label: "qMon/Fri", value: "qMon/Fri", fullLabel: "every Mon/Fri" },
      { label: "qMon/Sat", value: "qMon/Sat", fullLabel: "every Mon/Sat" },
      { label: "qMon/Thu", value: "qMon/Thu", fullLabel: "every Mon/Thu" },
      { label: "qMon/Tues", value: "qMon/Tues", fullLabel: "every Mon/Tues" },
      { label: "qMon/Tues/Thu/Fri", value: "qMon/Tues/Thu/Fri", fullLabel: "every Mon/Tues/Thu/Fri" },
      { label: "qMon/Tues/Thu/Fri/sat", value: "qMon/Tues/Thu/Fri/sat", fullLabel: "every Mon/Tues/Thu/Fri/Sat" },
      { label: "qMon/Tues/wed/Thu", value: "qMon/Tues/wed/Thu", fullLabel: "every 5 Mon/Tues/Wed/Thu" },
      { label: "qMon/Tues/Wed/Thu/Fri", value: "qMon/Tues/Wed/Thu/Fri", fullLabel: "every Mon/Tues/Wed/Thu/Fri" },
      {
        label: "qMon/Tues/Wed/Thu/Fri/Sat",
        value: "qMon/Tues/Wed/Thu/Fri/Sat", fullLabel: "every Mon/Tues/Wed/Thu/Fri" 
      },
      { label: "qMon/Wed", value: "qMon/Wed", fullLabel: "every Mon/Wed" },
      { label: "qMon/Wed/Fri", value: "qMon/Wed/Fri", fullLabel: "every Mon/Wed/Fri" },
      { label: "qMorning", value: "qMorning", fullLabel: "every Morning" },
      { label: "qMorning/Noon", value: "qMorning/Noon", fullLabel: "every Morning/Noon" },
      { label: "qSat (am&pm)", value: "qSat (am&pm)", fullLabel: "every Sat am&pm" },
      { label: "qSat/Sun", value: "qSat/Sun", fullLabel: "every Sat/Sun" },
      { label: "qSun", value: "qSun", fullLabel: "every Sun" },
      { label: "qSun (am&pm)", value: "qSun (am&pm)", fullLabel: "every Sun am&pm" },
      { label: "qSun/Mon", value: "qSun/Mon", fullLabel: "every Sun/Mon" },
      {
        label: "qSun/Mon/Tues/Wed/Fri/Sat",
        value: "qSun/Mon/Tues/Wed/Fri/Sat", fullLabel: "every Sun/Mon/Tues/Wed/Fri/Sat"
      },
      { label: "qSun/Mon/Tues/Thu/sat", value: "qSun/Mon/Tues/Thu/sat", fullLabel: "every Sun/Mon/Tues/Thu/sat" },
      { label: "qSun/Mon/Wed/Fri", value: "qSun/Mon/Wed/Fri", fullLabel: "every Sun/Mon/Wed/Fri" },
      { label: "qSun/Mon/Wed/Fri/Sat", value: "qSun/Mon/Wed/Fri/Sat", fullLabel: "every Sun/Mon/Wed/Fri/Sat" },
      { label: "qSun/Tues/Thu", value: "qSun/Tues/Thu", fullLabel: "every Sun/Tues/Thu" },
      { label: "qSun/Tues/Thu/Fri", value: "qSun/Tues/Thu/Fri", fullLabel: "every Sun/Tues/Thu/Fri" },
      { label: "qSun/Tues/Thu/Sat", value: "qSun/Tues/Thu/Sat", fullLabel: "every Sun/Tues/Thu/Sat" },
      { label: "qSun/Tues/Wed/Fri/Sat", value: "qSun/Tues/Wed/Fri/Sat", fullLabel: "every Sun/Tues/Wed/Fri/Sat" },
      { label: "qSun/Tues/Wed/Thu/Sat", value: "qSun/Tues/Wed/Thu/Sat", fullLabel: "every Sun/Tues/Wed/Thu/Sat" },
      { label: "qSun/Wed", value: "qSun/Wed", fullLabel: "every Sun/Wed" },
      { label: "qSun/Wed/sat", value: "qSun/Wed/sat", fullLabel: "every Sun/Wed/sat" },
      { label: "qSun/Wed/Thu/Fri/Sat", value: "qSun/Wed/Thu/Fri/Sat", fullLabel: "every Sun/Wed/Thu/Fri/Sat" },
      { label: "qThu", value: "qThu", fullLabel: "every Thu" },
      { label: "qTue", value: "qTue", fullLabel: "every Tue" },
      { label: "qTue/Fri", value: "qTue/Fri", fullLabel: "every Tue/Fri" },
      { label: "qTue/Sat", value: "qTue/Sat", fullLabel: "every Tue/Sat" },
      { label: "qTue/Thu", value: "qTue/Thu", fullLabel: "every Tue/Thu" },
      { label: "qTue/Thu/Sat", value: "qTue/Thu/Sat", fullLabel: "every Tue/Thu/Sat" },
      { label: "qTue/Wed/Thu", value: "qTue/Wed/Thu", fullLabel: "every Tue/Wed/Thu" },
      { label: "qWed", value: "qWed", fullLabel: "every Wed" },
      { label: "qWed/Fri", value: "qWed/Fri", fullLabel: "every Wed/Fri" },
      { label: "qWed/Sat", value: "qWed/Sat", fullLabel: "every Wed/Sat" },
      { label: "TID after meals", value: "TID after meals", fullLabel: "three times daily after meals" },
      { label: "TID after meals & HS", value: "TID after meals & HS", fullLabel: "three times daily after meals & HS" },
      { label: "TID before meals", value: "TID before meals", fullLabel: "three times daily before meals" },
      { label: "TID before meals & HS", value: "TID before meals & HS", fullLabel: "three times daily before meals & HS" },
      { label: "TID with meals", value: "TID with meals", fullLabel: "three times daily with meals" },
      { label: "TID with meals & HS", value: "TID with meals & HS", fullLabel: "three times daily with meals & HS" },
      { label: "Vaccine", value: "Vaccine"},
      { label: "with all meals", value: "with all meals"},
      { label: "with breakfast", value: "with breakfast"},
      { label: "with lunch", value: "with lunch"},
      { label: "with supper", value: "with supper"},
      { label: "with snacks", value: "with snacks"},
    ],
  },
];

export const getFullLabelByValue = (value) => {
  for (const group of frequencyOptions) {
    const foundOption = group.options.find(option => option.value === value);
    if (foundOption) {
      return `${foundOption?.fullLabel || foundOption?.label}`;
    }
  }
  return value;
};


export const nasalSalineRadioOptions = [
  {
    value: "treatmentOfChoice",
    label: "Select a Nasal Saline Rinse treatment of choice when filling Rx",
  },
  {
    value: "searchTreatment",
    label: "Search for a Nasal Saline Rinse treatment",
  },
];

export const dispenseOptions = [
  { value: "20ml", label: "20ml" },
  { value: "25ml", label: "25ml" },
  { value: "50ml", label: "50ml" },
  { value: "100ml", label: "100ml" },
  { value: "200ml", label: "200ml" },
];

export const dispenseTabletOptions = [
  { value: "7 tablets", label: "7 tablets" },
  { value: "10 tablets", label: "10 tablets" },
  { value: "14 tablets", label: "14 tablets" },
  { value: "21 tablets", label: "21 tablets" },
  { value: "30 tablets", label: "30 tablets" },
  { value: "60 tablets", label: "60 tablets" },
  { value: "90 tablets", label: "90 tablets" },
];

export const medicationFilterOptions = [
  {
    label: "Drug Type",
    options: [
      { value: "All", label: "All", group: "drugType" },
      { value: "Din", label: "DIN", group: "drugType" },
      { value: "Brand", label: "Brand", group: "drugType" },
      { value: "Gen", label: "Generic (Product)", shortLabel: "Generic", group: "drugType" },
      { value: "Generx", label: "Generic (Generx)", shortLabel: "Gen. Class", group: "drugType" },
      { value: "Sentence", label: "Drug Sentence", group: "drugType" },
    ],
  },
  {
    label: "Manufacturer Type",
    options: [
      { value: "Short", label: "Short Code", group: "manufacturerType" },
      { value: "Full", label: "Full Name", group: "manufacturerType" },
      { value: "None", label: "None", group: "manufacturerType" },
    ],
  },
];

// Form options — combined Matched + Close Match flat list
export const FORM_OPTIONS = [
  { label: "Aerosol", value: "AEROSOL" },
  { label: "Cap", value: "CAPSULE" },
  { label: "Caplet", value: "CAPLET" },
  { label: "Cartridge", value: "CARTRIDGE" },
  { label: "Chew Tab", value: "CHEWTAB" },
  { label: "Cream", value: "CREAM" },
  { label: "CR Tab", value: "ERTAB" },
  { label: "Device", value: "DEVICE" },
  { label: "DIS Tab", value: "DISINTAB" },
  { label: "DR Cap", value: "ENTCAP" },
  { label: "DR Tab", value: "DR-TABLET" },
  { label: "Dressing", value: "DRESSING" },
  { label: "Drop", value: "DROP" },
  { label: "EC Cap", value: "ENTCAP" },
  { label: "EC Granules", value: "ENT. GRANULE" },
  { label: "EC Tab", value: "ENTERIC TAB." },
  { label: "EFF Tab", value: "EFFERV. TAB." },
  { label: "Elixir", value: "ELIXIR" },
  { label: "Enema", value: "ENEMA" },
  { label: "ER Cap", value: "ERCAP" },
  { label: "ER Tab", value: "ERTAB" },
  { label: "Film", value: "BUCCAL FILM" },
  { label: "Foam", value: "FOAM" },
  { label: "Gel", value: "GEL" },
  { label: "Granules", value: "GRANULE" },
  { label: "Gum", value: "GUM" },
  { label: "Implant", value: "IMPLANT" },
  { label: "INJ", value: "INJECTABLE" },
  { label: "INJ Powder", value: "INJ.POWDER" },
  { label: "LA Cap", value: "LA-CAPSULE" },
  { label: "Liquid", value: "LIQUID" },
  { label: "Lotion", value: "LOTION" },
  { label: "Lozenge", value: "LOZENGE" },
  { label: "Mouthwash", value: "MOUTHWASH" },
  { label: "Nasal Drops", value: "NASAL DROPS" },
  { label: "Nasal Gel", value: "NASAL GEL" },
  { label: "Nasal Irrigation", value: "NASAL RINSE" },
  { label: "Nasal Solution", value: "NASAL SOL." },
  { label: "Nasal Spray", value: "NASAL SPRAY" },
  { label: "Ointment", value: "OINTMENT" },
  { label: "OPHTH Gel", value: "OPGEL" },
  { label: "OPHTH Ointment", value: "OPHT. OINT." },
  { label: "Packet", value: "PACKET" },
  { label: "Pad", value: "PAD" },
  { label: "Paste", value: "PASTE" },
  { label: "Patch", value: "PATCH" },
  { label: "PO Liquid", value: "ORAL LIQUID" },
  { label: "Powder", value: "POWDER" },
  { label: "Ring", value: "VAGINAL RING" },
  { label: "Shampoo", value: "SHAMPOO" },
  { label: "Soap", value: "SOAP" },
  { label: "Solution", value: "SOLUTION" },
  { label: "Sponge", value: "SPONGE" },
  { label: "Spray", value: "SPRAY" },
  { label: "SR Cap", value: "LA-CAPSULE" },
  { label: "SR Tab", value: "LA-TABLET" },
  { label: "Stick", value: "STICK" },
  { label: "Suppository", value: "SUPPOSITORY" },
  { label: "Suspension", value: "SUSPENSION" },
  { label: "Swab", value: "MEDSWAB" },
  { label: "Syringe", value: "SYRINGE" },
  { label: "Syrup", value: "SYRUP" },
  { label: "Tablet", value: "TABLET" },
  { label: "Tampon", value: "VAG. TAMPON" },
  { label: "Test", value: "TEST" },
  { label: "Tincture", value: "TINCTURE" },
  { label: "Topical Liquid", value: "TOP. LIQUID" },
  { label: "Topical Solution", value: "TOPSOL" },
  { label: "Vaginal Cream", value: "VAG. CREAM" },
  { label: "Vaginal Gel", value: "VAGINAL GEL" },
  { label: "Wafer", value: "WAFER" },
  { label: "XL Cap", value: "LA-CAPSULE" },
  { label: "XL Tab", value: "LA-TABLET" },
  { label: "XR Cap", value: "ERCAP24" },
  { label: "XR Tab", value: "ERTAB24" },
];

export const ROUTE_OPTIONS = [
  { label: 'Bath', value: 'Bath', beValue: 'bath' },
  { label: 'BLADIRR', value: 'BLADIRR', beValue: 'BLADIRR' },
  { label: 'bl_irrig', value: 'bl_irrig', beValue: 'bl_irrig' },
  { label: 'Buccal', value: 'Buccal', beValue: 'buccal' },
  { label: 'BUC', value: 'BUC', beValue: 'BUC' },
  { label: 'Cervical', value: 'Cervical', beValue: 'cervical' },
  { label: 'CHEW', value: 'CHEW', beValue: 'CHEW' },
  { label: 'DEN', value: 'DEN', beValue: 'DEN' },
  { label: 'Dialysis', value: 'Dialysis', beValue: 'HEMODIFF' },
  { label: 'DISSOLVE', value: 'DISSOLVE', beValue: 'DISSOLVE' },
  { label: 'DOUCHE', value: 'DOUCHE', beValue: 'DOUCHE' },
  { label: 'Ear', value: 'Ear', beValue: 'otic' },
  { label: 'Ear-Both', value: 'Ear-Both', beValue: 'otic' },
  { label: 'Ear-Left', value: 'Ear-Left', beValue: 'otic' },
  { label: 'Ear-Right', value: 'Ear-Right', beValue: 'otic' },
  { label: 'ENEMA', value: 'ENEMA', beValue: 'ENEMA' },
  { label: 'endotrac', value: 'endotrac', beValue: 'endotrac' },
  { label: 'Enteral Tube', value: 'Enteral Tube', beValue: 'nasogast' },
  { label: 'epidural', value: 'epidural', beValue: 'epidural' },
  { label: 'EXTCORPINJ', value: 'EXTCORPINJ', beValue: 'EXTCORPINJ' },
  { label: 'Eye', value: 'Eye', beValue: 'ophthalmic' },
  { label: 'Eye-Both', value: 'Eye-Both', beValue: 'ophthalmic' },
  { label: 'Eye-Left', value: 'Eye-Left', beValue: 'ophthalmic' },
  { label: 'Eye-Right', value: 'Eye-Right', beValue: 'ophthalmic' },
  { label: 'Feeding Tube', value: 'Feeding Tube', beValue: 'nasogast' },
  { label: 'G-Tube', value: 'G-Tube', beValue: 'nasogast' },
  { label: 'G-Tube/J-Tube', value: 'G-Tube/J-Tube', beValue: 'nasogast' },
  { label: 'gargle', value: 'gargle', beValue: 'gargle' },
  { label: 'GIN', value: 'GIN', beValue: 'GIN' },
  { label: 'HEMODIFF', value: 'HEMODIFF', beValue: 'HEMODIFF' },
  { label: 'IARTINJ', value: 'IARTINJ', beValue: 'IARTINJ' },
  { label: 'ID', value: 'ID', beValue: 'ID' },
  { label: 'IDUODINSTIL', value: 'IDUODINSTIL', beValue: 'IDUODINSTIL' },
  { label: 'ILESINJ', value: 'ILESINJ', beValue: 'ILESINJ' },
  { label: 'ILESIRR', value: 'ILESIRR', beValue: 'ILESIRR' },
  { label: 'IM', value: 'IM', beValue: 'IM' },
  { label: 'IM Plant', value: 'IM Plant', beValue: 'SQIMPLNT' },
  { label: 'Infiltration', value: 'Infiltration', beValue: 'PARENTINJ' },
  { label: 'inh', value: 'inh', beValue: 'inh' },
  { label: 'Inhale', value: 'Inhale', beValue: 'inhalation' },
  { label: 'in_artic', value: 'in_artic', beValue: 'in_artic' },
  { label: 'in_caver', value: 'in_caver', beValue: 'in_caver' },
  { label: 'IntraCatheter', value: 'IntraCatheter', beValue: 'IV' },
  { label: 'IntraDERMAL', value: 'IntraDERMAL', beValue: 'intradermal' },
  { label: 'in_derma', value: 'in_derma', beValue: 'in_derma' },
  { label: 'in_lesio', value: 'in_lesio', beValue: 'in_lesio' },
  { label: 'Intranasal', value: 'Intranasal', beValue: 'nasal' },
  { label: 'in_ocula', value: 'in_ocula', beValue: 'in_ocula' },
  { label: 'IntraOCULAR', value: 'IntraOCULAR', beValue: 'ophthalmic' },
  { label: 'in_perit', value: 'in_perit', beValue: 'in_perit' },
  { label: 'in_theca', value: 'in_theca', beValue: 'in_theca' },
  { label: 'in_uteri', value: 'in_uteri', beValue: 'in_uteri' },
  { label: 'in_vesic', value: 'in_vesic', beValue: 'in_vesic' },
  { label: 'in_vitre', value: 'in_vitre', beValue: 'in_vitre' },
  { label: 'inhalation', value: 'inhalation', beValue: 'inhalation' },
  { label: 'intraarticular', value: 'intraarticular', beValue: 'intraarticular' },
  { label: 'intracavernosal', value: 'intracavernosal', beValue: 'intracavernosal' },
  { label: 'intradermal', value: 'intradermal', beValue: 'intradermal' },
  { label: 'intramuscular', value: 'intramuscular', beValue: 'intramuscular' },
  { label: 'intrathecal', value: 'intrathecal', beValue: 'intrathecal' },
  { label: 'intrauterine', value: 'intrauterine', beValue: 'intrauterine' },
  { label: 'intravenous', value: 'intravenous', beValue: 'intravenous' },
  { label: 'intravenous continuous', value: 'intravenous continuous', beValue: 'intravenous continuous' },
  { label: 'intravitreous', value: 'intravitreous', beValue: 'intravitreous' },
  { label: 'IOINJ', value: 'IOINJ', beValue: 'IOINJ' },
  { label: 'IOINSTL', value: 'IOINSTL', beValue: 'IOINSTL' },
  { label: 'Irrigation', value: 'Irrigation', beValue: 'irrigati' },
  { label: 'irrigati', value: 'irrigati', beValue: 'irrigati' },
  { label: 'ITINJ', value: 'ITINJ', beValue: 'ITINJ' },
  { label: 'ITRACHMAB', value: 'ITRACHMAB', beValue: 'ITRACHMAB' },
  { label: 'IU', value: 'IU', beValue: 'IU' },
  { label: 'IUINJ', value: 'IUINJ', beValue: 'IUINJ' },
  { label: 'IV', value: 'IV', beValue: 'IV' },
  { label: 'IV continuous', value: 'IV continuous', beValue: 'IV continuous' },
  { label: 'IV-SYRINGE', value: 'IV-SYRINGE', beValue: 'IV' },
  { label: 'IVFLUSH', value: 'IVFLUSH', beValue: 'IVFLUSH' },
  { label: 'IVITIMPLNT', value: 'IVITIMPLNT', beValue: 'IVITIMPLNT' },
  { label: 'IVITINJ', value: 'IVITINJ', beValue: 'IVITINJ' },
  { label: 'Mouthwash', value: 'Mouthwash', beValue: 'mouthwash' },
  { label: 'Mucous Membrane', value: 'Mucous Membrane', beValue: 'ORMUC' },
  { label: 'NAIL', value: 'NAIL', beValue: 'NAIL' },
  { label: 'Nasal', value: 'Nasal', beValue: 'nasal' },
  { label: 'NASAL', value: 'NASAL', beValue: 'NASAL' },
  { label: 'NASINHL', value: 'NASINHL', beValue: 'NASINHL' },
  { label: 'NASINHLC', value: 'NASINHLC', beValue: 'NASINHLC' },
  { label: 'Nasogast', value: 'Nasogast', beValue: 'nasogast' },
  { label: 'NG-Tube', value: 'NG-Tube', beValue: 'nasogast' },
  { label: 'Nostril', value: 'Nostril', beValue: 'nasal' },
  { label: 'Nostril-Alternating', value: 'Nostril-Alternating', beValue: 'nasal' },
  { label: 'Nostril-BOTH', value: 'Nostril-BOTH', beValue: 'nasal' },
  { label: 'Nostril-LEFT', value: 'Nostril-LEFT', beValue: 'nasal' },
  { label: 'Nostril-RIGHT', value: 'Nostril-RIGHT', beValue: 'nasal' },
  { label: 'Ophthalmic', value: 'Ophthalmic', beValue: 'ophthalmic' },
  { label: 'ophthalm', value: 'ophthalm', beValue: 'ophthalm' },
  { label: 'Ophth', value: 'Ophth', beValue: 'ophthalmic' },
  { label: 'OPTHALTA', value: 'OPTHALTA', beValue: 'OPTHALTA' },
  { label: 'Oral', value: 'Oral', beValue: 'oral' },
  { label: 'oral_neb', value: 'oral_neb', beValue: 'oral_neb' },
  { label: 'ORINHL', value: 'ORINHL', beValue: 'ORINHL' },
  { label: 'ORMUC', value: 'ORMUC', beValue: 'ORMUC' },
  { label: 'ORNEB', value: 'ORNEB', beValue: 'ORNEB' },
  { label: 'ORRINSE', value: 'ORRINSE', beValue: 'ORRINSE' },
  { label: 'OT', value: 'OT', beValue: 'OT' },
  { label: 'Otic', value: 'Otic', beValue: 'otic' },
  { label: 'otic_irr', value: 'otic_irr', beValue: 'otic_irr' },
  { label: 'PARENTINJ', value: 'PARENTINJ', beValue: 'PARENTINJ' },
  { label: 'PDPINSTL', value: 'PDPINSTL', beValue: 'PDPINSTL' },
  { label: 'PO', value: 'PO', beValue: 'PO' },
  { label: 'PO/Feeding tTube', value: 'PO/Feeding tTube', beValue: 'PO' },
  { label: 'PR', value: 'PR', beValue: 'PR' },
  { label: 'Rectal', value: 'Rectal', beValue: 'rectal' },
  { label: 'RECTAL', value: 'RECTAL', beValue: 'RECTAL' },
  { label: 'RETENEMA', value: 'RETENEMA', beValue: 'RETENEMA' },
  { label: 'SC', value: 'SC', beValue: 'SC' },
  { label: 'SC continuous', value: 'SC continuous', beValue: 'SC continuous' },
  { label: 'SCALP', value: 'SCALP', beValue: 'SCALP' },
  { label: 'SHAMPOO', value: 'SHAMPOO', beValue: 'SHAMPOO' },
  { label: 'SKIN', value: 'SKIN', beValue: 'SKIN' },
  { label: 'SL', value: 'SL', beValue: 'SL' },
  { label: 'Soak', value: 'Soak', beValue: 'bath' },
  { label: 'SQ', value: 'SQ', beValue: 'SQ' },
  { label: 'SQIMPLNT', value: 'SQIMPLNT', beValue: 'SQIMPLNT' },
  { label: 'SUBCUT', value: 'SUBCUT', beValue: 'subcutaneous' },
  { label: 'Subcutaneous', value: 'Subcutaneous', beValue: 'subcutaneous' },
  { label: 'SubDERMAL', value: 'SubDERMAL', beValue: 'subcutaneous' },
  { label: 'SubMUCOSAL', value: 'SubMUCOSAL', beValue: 'ORMUC' },
  { label: 'Sublingual', value: 'Sublingual', beValue: 'sublingual' },
  { label: 'sublingu', value: 'sublingu', beValue: 'sublingu' },
  { label: 'SUCK', value: 'SUCK', beValue: 'SUCK' },
  { label: 'Swish+Spit', value: 'Swish+Spit', beValue: 'SWISHSPIT' },
  { label: 'Swish+Swallow', value: 'Swish+Swallow', beValue: 'mouthwash' },
  { label: 'SWISHSPIT', value: 'SWISHSPIT', beValue: 'SWISHSPIT' },
  { label: 'TOPICAL', value: 'TOPICAL', beValue: 'TOPICAL' },
  { label: 'Topical', value: 'Topical', beValue: 'topical' },
  { label: 'topic', value: 'topic', beValue: 'topic' },
  { label: 'TRNSDERM', value: 'TRNSDERM', beValue: 'TRNSDERM' },
  { label: 'TRNSLING', value: 'TRNSLING', beValue: 'TRNSLING' },
  { label: 'TransDERMAL', value: 'TransDERMAL', beValue: 'transdermal' },
  { label: 'transder', value: 'transder', beValue: 'transder' },
  { label: 'Ureter', value: 'Ureter', beValue: 'urethral' },
  { label: 'Urethral', value: 'Urethral', beValue: 'urethral' },
  { label: 'URETHSUP', value: 'URETHSUP', beValue: 'URETHSUP' },
  { label: 'Vaginal', value: 'Vaginal', beValue: 'vaginal' },
  { label: 'vag_irri', value: 'vag_irri', beValue: 'vag_irri' },
  { label: 'VAGINS', value: 'VAGINS', beValue: 'VAGINS' },
  { label: 'VAGINSI', value: 'VAGINSI', beValue: 'VAGINSI' },
  { label: 'Z-Track Injection', value: 'Z-Track Injection', beValue: 'intramuscular' },
];

export const MedicineOptions = [
  {
    label: "None",
    value: "none",
    displayText: "None",
    identifier: "0",
    type: "0",
  },
  {
    label: "Not Specified",
    value: "not_specified",
    displayText: "Not Specified",
    identifier: "1",
    type: "1",
  },
];

export const routineEnum = {
  question: "Do you forget to take your medication?",
  subquestion: null,
  options: [
    { value: "Yes", header: "Yes", subHeader: null },
    { value: "No", header: "No", subHeader: null },
    { value: "NotSure", header: "Not Sure", subHeader: null },
  ],
};

export const routineTypeEnum = {
  question: "How often do you forget?",
  subquestion: null,
  options: [
    { value: "Usually", header: "Usually", subHeader: null },
    { value: "Sometimes", header: "Sometimes", subHeader: null },
    { value: "OnceInAwhile", header: "Occasional", subHeader: null },
  ],
};

export const complianceEnum = {
  question: "If you feel no symptoms, do you stop taking your medication?",
  subquestion: null,
  options: [
    { value: "Yes", header: "Yes", subHeader: null },
    { value: "No", header: "No", subHeader: null },
  ],
};

export const refillEnum = {
  question: "When do you get your medication refills?",
  subquestion: null,
  options: [
    { value: "OnTime", header: "On Time", subHeader: null },
    { value: "Early", header: "Early", subHeader: null },
    { value: "Late", header: "Late", subHeader: null },
  ],
};

export const drugTypes = {
  Additional: "additionalMedication",
  Prescription: "prescription",
  PrescribedRx: "PrescribedRx",
  HistoryPrescribedRx: "HistoryPrescribedRx",
};

export const medicationTypeOptions = [
  { value: drugTypes.Prescription, label: "Prescription" },
  { value: drugTypes.Additional, label: "Additional Medication" },
  { value: drugTypes.PrescribedRx, label: "Prescribed - Pending Dispense" },
  { value: "Vaccine", label: "Vaccine" },
];

export const vaccineDoseTypeOptions = [
  { value: "Single Dose", label: "Single Dose" },
  { value: "Initial", label: "Initial (Series)" },
  { value: "Booster Dose", label: "Booster Dose" },
];

export const therapyTypeOptions = [
  { value: "chronic_continuous", label: "Chronic / continuous" },
  { value: "acute_short_term", label: "Acute / short-term" },
];

export const vaccineReasonOptions = [
  { value: "vaccine history", label: "vaccine history" },
  { value: "vaccine schedule", label: "vaccine schedule" },
];

export const totalVaccineDoseOptions = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const specialInstructionOptions = [
  { value: "None", label: "None" },
  { value: "Other", label: "Add Custom Instructions" },
  { value: "Avoid anti-inflammatories", label: "Avoid anti-inflammatories" },
  {
    value:
      "Avoid antacids or magnesium (2 hours before or after taking medication)",
    label: "Avoid antacids or magnesium",
    subLabel: "(2 hours before or after taking medication)",
  },
  { value: "Avoid dairy", label: "Avoid dairy" },
  { value: "Avoid direct sunlight", label: "Avoid direct sunlight" },
  {
    value: "Avoid grapefruit, orange or apple juice",
    label: "Avoid grapefruit, orange or apple juice",
  },
  { value: "Avoid grapefruit", label: "Avoid grapefruit" },
  {
    value:
      "Avoid iron, calcium or multivitamins (6 hours before and 2 hours after this medication)",
    label: "Avoid iron, calcium or multivitamins",
    subLabel: "(6 hours before and 2 hours after this medication)",
  },
  { value: "Drink plenty of water", label: "Drink plenty of water" },
  { value: "Keep refrigerated", label: "Keep refrigerated" },
  { value: "May cause drowsiness", label: "May cause drowsiness" },
  {
    value:
      "Monitor blood pressure at home (record readings and bring to appointments)",
    label: "Monitor blood pressure at home",
    subLabel: "Record readings and bring to appointments",
  },
  {
    value:
      "Monitor blood sugar at home (record results regularly and bring to appointments)",
    label: "Monitor blood sugar at home",
    subLabel: "Record results regularly and bring to appointments",
  },
  { value: "NO alcohol", label: "NO alcohol" },
  { value: "Refrigerate", label: "Refrigerate" },
  {
    value: "Swallow whole, do not open capsule",
    label: "Swallow whole, do not open capsule",
  },
  { value: "Take at the same time each day", label: "Take at the same time each day" },
  {
    value: "Take on an empty stomach (at least 1 hour before a meal)",
    label: "Take on an empty stomach",
    subLabel: "(at least 1 hour before a meal)",
  },
  {
    value:
      "Take on an empty stomach (at least 30 minutes before or 2 hours after a meal)",
    label: "Take on an empty stomach",
    subLabel: "(at least 30 minutes before or 2 hours after a meal)",
  },
  { value: "Take on an empty stomach", label: "Take on an empty stomach" },
  { value: "Take with food", label: "Take with food" },
  {
    value: "Treat low blood sugar with glucose tablets",
    label: "Treat low blood sugar with glucose tablets",
  },
];
